import { ReactComponent as IconMenu } from "@/assets/svgs/menu-dark-small.svg";
import classname from "classnames";
import { useEffect, useRef, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { usePopper } from "react-popper";
import MenuItems from "./MenuItems";

export default function MultiLevelDropDown({
	button: Button,
	menuList,
	placement = "bottom-end",
	modifiers = [
		{
			name: "offset",
			options: { offset: [0, 2] },
		},
	],
	closeAll: closeAllParent = undefined,
	setCloseAll: setCloseAllParent = undefined,
}) {
	const [visible, setVisible] = useState(false);
	const [closeAll, setCloseAll] = useState(true);

	const referenceRef = useRef(null);
	const popperRef = useRef(null);

	const { styles, attributes, update } = usePopper(
		referenceRef.current,
		popperRef.current,
		{
			placement,
			modifiers,
		}
	);

	const containerStyle = {
		...styles.popper,
		display: visible && !closeAll ? "flex" : "none",
		zIndex: 999,
	};

	const menuBtnClass = classname({
		"package__menu-btn": true,
		"active-btn": visible && !closeAll,
	});

	useEffect(() => {
		if (closeAllParent) {
			setCloseAll(true);
		}
	}, [closeAllParent]);

	const handleClickOutside = () => {
		setVisible(false);
	};

	const hideAll = () => {
		if (setCloseAllParent) {
			setCloseAllParent(true);
		}
		setCloseAll(true);
	};

	function handleDropdownClick(e) {
		e.preventDefault();
		e.stopPropagation();
		setVisible(true);
		setCloseAll(false);

		if (typeof update === "function") {
			update(); // Fix to update position of popper
		}
	}

	return (
		<>
			<span
				ref={referenceRef}
				onClick={handleDropdownClick}
				data-testid="menu-btn"
			>
				{Button ? (
					<Button />
				) : (
					<span className={menuBtnClass}>
						<IconMenu />
					</span>
				)}
			</span>
			<div ref={popperRef} style={containerStyle} {...attributes.popper}>
				<OutsideClickHandler onOutsideClick={handleClickOutside}>
					<div className="menu-dropdown__card">
						{menuList
							?.filter((item) => item !== undefined)
							?.map((item) => (
								<MenuItems
									key={item.label}
									item={item}
									hide={hideAll}
									closeAll={
										closeAllParent !== undefined
											? closeAllParent
											: closeAll
									}
									setCloseAll={
										setCloseAllParent !== undefined
											? setCloseAllParent
											: setCloseAll
									}
								/>
							))}
					</div>
				</OutsideClickHandler>
			</div>
		</>
	);
}
